// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@charset \"UTF-8\";\n[data-v-58a837a0] .input-border.el-input--mini .el-input__inner {\n  height: 60px;\n  font-size: 40px;\n  line-height: 28px;\n}\n.centered-cell[data-v-58a837a0] {\n  text-align: center;\n  /* 文字居中对齐 */\n  width: 30%;\n}\n", ""]);
// Exports
module.exports = exports;
